<script>
  export let assetsPath = './';
  let width = null;
  import { onMount } from 'svelte';
  export let onAiMounted = () => {};
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-years-outlines-box" bind:clientWidth={width}>
  <!-- Artboard: xs -->
  {#if width && width >= 0 && width < 510}
    <div id="g-years-outlines-xs" class="g-artboard" style="">
      <div style="padding: 0 0 386.3636% 0;"></div>
      <div
        id="g-years-outlines-xs-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/years-outlines-xs.jpg);"
      ></div>
      <div
        id="g-ai0-1"
        class="g-explainer-text_copy_4 g-aiAbs g-aiPointText"
        style="top:3.6972%;margin-top:-24.1px;left:11.9929%;width:140px;"
      >
        <p class="g-pstyle0">Each grey line follows</p>
        <p class="g-pstyle0">the silhouette of an</p>
        <p class="g-pstyle0">outfit worn that year</p>
      </div>
      <div
        id="g-ai0-2"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.6875935014829%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.6875935014829%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.6875935014829%;top:8.5964%;margin-top:-18.6px;left:77.7797%;margin-left:-33px;width:66px;"
      >
        <p class="g-pstyle1">Fitted</p>
        <p class="g-pstyle1">torsos</p>
      </div>
      <div
        id="g-ai0-3"
        class="g-years_copy_4 g-aiAbs g-aiPointText"
        style="top:13.4999%;margin-top:-11.1px;right:3.0253%;width:66px;"
      >
        <p class="g-pstyle2">2004</p>
      </div>
      <div
        id="g-ai0-4"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);transform-origin: 50% 52.9052530038444%;-webkit-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-webkit-transform-origin: 50% 52.9052530038444%;-ms-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-ms-transform-origin: 50% 52.9052530038444%;top:14.84%;margin-top:-17.2px;left:12.9392%;margin-left:-48px;width:96px;"
      >
        <p class="g-pstyle1">More layers</p>
        <p class="g-pstyle1">and ruffles</p>
      </div>
      <div
        id="g-ai0-5"
        class="g-theme_copy_4 g-aiAbs"
        style="top:14.4314%;right:3.0303%;width:44.2424%;"
      >
        <p class="g-pstyle3">
          Dangerous Liaisons, Fashion and Furniture in the 18th century
        </p>
      </div>
      <div
        id="g-ai0-6"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);transform-origin: 50% 52.8718869194525%;-webkit-transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);-webkit-transform-origin: 50% 52.8718869194525%;-ms-transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);-ms-transform-origin: 50% 52.8718869194525%;top:26.6204%;margin-top:-17.4px;left:88.1706%;margin-left:-49.5px;width:99px;"
      >
        <p class="g-pstyle1">Structured</p>
        <p class="g-pstyle1">shapes</p>
      </div>
      <div
        id="g-ai0-7"
        class="g-years_copy_4 g-aiAbs g-aiPointText"
        style="top:29.0293%;margin-top:-11.1px;left:2.4345%;width:65px;"
      >
        <p class="g-pstyle4">2009</p>
      </div>
      <div
        id="g-ai0-8"
        class="g-theme_copy_4 g-aiAbs"
        style="top:29.8824%;left:2.4344%;width:33.9394%;"
      >
        <p class="g-pstyle5">The Model as Muse:</p>
        <p class="g-pstyle5">Embodying Fashion</p>
      </div>
      <div
        id="g-ai0-9"
        class="g-years_copy_4 g-aiAbs g-aiPointText"
        style="top:42.1274%;margin-top:-11.1px;right:2.9745%;width:61px;"
      >
        <p class="g-pstyle2">2014</p>
      </div>
      <div
        id="g-ai0-10"
        class="g-theme_copy_4 g-aiAbs"
        style="top:42.902%;right:3.0303%;width:27.8788%;"
      >
        <p class="g-pstyle3">Charles James:</p>
        <p class="g-pstyle3">Beyond Fashion</p>
      </div>
      <div
        id="g-ai0-11"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 54.8970612850004%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 54.8970612850004%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 54.8970612850004%;top:49.8988%;margin-top:-10.2px;left:14.5782%;margin-left:-44.5px;width:89px;"
      >
        <p class="g-pstyle1">Headpieces</p>
      </div>
      <div
        id="g-ai0-12"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.8718869194525%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.8718869194525%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.8718869194525%;top:56.7381%;margin-top:-17.4px;left:87.4235%;margin-left:-55px;width:110px;"
      >
        <p class="g-pstyle1">Breaking the</p>
        <p class="g-pstyle1">gown format</p>
      </div>
      <div
        id="g-ai0-13"
        class="g-years_copy_4 g-aiAbs g-aiPointText"
        style="top:69.1862%;margin-top:-11.1px;left:2.4343%;width:61px;"
      >
        <p class="g-pstyle4">2019</p>
      </div>
      <div
        id="g-ai0-14"
        class="g-theme_copy_4 g-aiAbs"
        style="top:69.9608%;left:2.4344%;width:44.5455%;"
      >
        <p class="g-pstyle5">Camp: Notes on Fashion</p>
      </div>
      <div
        id="g-ai0-15"
        class="g-annot_copy_4 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);transform-origin: 50% 52.0316855649137%;-webkit-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-webkit-transform-origin: 50% 52.0316855649137%;-ms-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-ms-transform-origin: 50% 52.0316855649137%;top:84.0479%;margin-top:-24.6px;left:82.4445%;margin-left:-63.5px;width:127px;"
      >
        <p class="g-pstyle1">Petals, feathers,</p>
        <p class="g-pstyle1">shimmering</p>
        <p class="g-pstyle1">textures</p>
      </div>
      <div
        id="g-ai0-16"
        class="g-years_copy_4 g-aiAbs g-aiPointText"
        style="top:94.6764%;margin-top:-11.1px;left:2.4345%;width:64px;"
      >
        <p class="g-pstyle6">2024</p>
      </div>
      <div
        id="g-ai0-17"
        class="g-theme_copy_4 g-aiAbs g-aiPointText"
        style="top:95.9779%;margin-top:-8.7px;left:2.4345%;width:131px;"
      >
        <p class="g-pstyle7">The Garden of Time</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: sm -->
  {#if width && width >= 510 && width < 660}
    <div id="g-years-outlines-sm" class="g-artboard" style="">
      <div style="padding: 0 0 299.4118% 0;"></div>
      <div
        id="g-years-outlines-sm-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/years-outlines-sm.jpg);"
      ></div>
      <div
        id="g-ai1-1"
        class="g-explainer-text_copy_3 g-aiAbs g-aiPointText"
        style="top:3.0042%;margin-top:-24.9px;left:30.8743%;width:144px;"
      >
        <p class="g-pstyle0">Each grey line follows</p>
        <p class="g-pstyle0">the silhouette of an</p>
        <p class="g-pstyle0">outfit worn that year</p>
      </div>
      <div
        id="g-ai1-2"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.2688247089191%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.2688247089191%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.2688247089191%;top:10.1531%;margin-top:-22px;left:78.9897%;margin-left:-37px;width:74px;"
      >
        <p class="g-pstyle1">Fitted</p>
        <p class="g-pstyle1">torsos</p>
      </div>
      <div
        id="g-ai1-3"
        class="g-years_copy_3 g-aiAbs g-aiPointText"
        style="top:14.1867%;margin-top:-14.6px;right:2.1036%;width:80px;"
      >
        <p class="g-pstyle2">2004</p>
      </div>
      <div
        id="g-ai1-4"
        class="g-theme_copy_3 g-aiAbs g-aiPointText"
        style="top:16.6287%;margin-top:-26.9px;right:2.1572%;width:180px;"
      >
        <p class="g-pstyle3">Dangerous Liaisons,</p>
        <p class="g-pstyle3">Fashion and Furniture in</p>
        <p class="g-pstyle3">the 18th century</p>
      </div>
      <div
        id="g-ai1-5"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);transform-origin: 50% 52.5322716256986%;-webkit-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-webkit-transform-origin: 50% 52.5322716256986%;-ms-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-ms-transform-origin: 50% 52.5322716256986%;top:18.5164%;margin-top:-19.7px;left:9.0024%;margin-left:-54px;width:108px;"
      >
        <p class="g-pstyle4">More layers</p>
        <p class="g-pstyle4">and ruffles</p>
      </div>
      <div
        id="g-ai1-6"
        class="g-years_copy_3 g-aiAbs g-aiPointText"
        style="top:28.5286%;margin-top:-14.6px;left:2.0001%;width:79px;"
      >
        <p class="g-pstyle5">2009</p>
      </div>
      <div
        id="g-ai1-7"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.9633,-0.2685,0.2685,0.9633,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:29.9702%;margin-top:-20.6px;left:91.177%;margin-left:-56px;width:112px;"
      >
        <p class="g-pstyle1">Structured</p>
        <p class="g-pstyle1">shapes</p>
      </div>
      <div
        id="g-ai1-8"
        class="g-theme_copy_3 g-aiAbs g-aiPointText"
        style="top:30.5449%;margin-top:-18.4px;left:2.0001%;width:148px;"
      >
        <p class="g-pstyle6">The Model as Muse:</p>
        <p class="g-pstyle6">Embodying Fashion</p>
      </div>
      <div
        id="g-ai1-9"
        class="g-years_copy_3 g-aiAbs g-aiPointText"
        style="top:40.9713%;margin-top:-14.6px;right:2.1463%;width:73px;"
      >
        <p class="g-pstyle2">2014</p>
      </div>
      <div
        id="g-ai1-10"
        class="g-theme_copy_3 g-aiAbs g-aiPointText"
        style="top:42.9876%;margin-top:-18.4px;right:2.0695%;width:124px;"
      >
        <p class="g-pstyle3">Charles James:</p>
        <p class="g-pstyle3">Beyond Fashion</p>
      </div>
      <div
        id="g-ai1-11"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9975,-0.071,0.071,0.9975,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.9975,-0.071,0.071,0.9975,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.9975,-0.071,0.071,0.9975,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:47.9532%;margin-top:-12.2px;left:16.7245%;margin-left:-50px;width:100px;"
      >
        <p class="g-pstyle1">Headpieces</p>
      </div>
      <div
        id="g-ai1-12"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:54.8556%;margin-top:-20.6px;left:84.6827%;margin-left:-62.5px;width:125px;"
      >
        <p class="g-pstyle1">Breaking the</p>
        <p class="g-pstyle1">gown format</p>
      </div>
      <div
        id="g-ai1-13"
        class="g-years_copy_3 g-aiAbs g-aiPointText"
        style="top:69.5895%;margin-top:-14.6px;left:2.0001%;width:73px;"
      >
        <p class="g-pstyle5">2019</p>
      </div>
      <div
        id="g-ai1-14"
        class="g-theme_copy_3 g-aiAbs"
        style="top:70.5305%;left:2.0001%;width:32.1569%;"
      >
        <p class="g-pstyle7">Camp: Notes on Fashion</p>
      </div>
      <div
        id="g-ai1-15"
        class="g-annot_copy_3 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);transform-origin: 50% 51.7214568501038%;-webkit-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-webkit-transform-origin: 50% 51.7214568501038%;-ms-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-ms-transform-origin: 50% 51.7214568501038%;top:85.7921%;margin-top:-29px;left:73.5602%;margin-left:-72px;width:144px;"
      >
        <p class="g-pstyle1">Petals, feathers,</p>
        <p class="g-pstyle1">shimmering</p>
        <p class="g-pstyle1">textures</p>
      </div>
      <div
        id="g-ai1-16"
        class="g-years_copy_3 g-aiAbs g-aiPointText"
        style="top:96.7015%;margin-top:-14.6px;left:2.0001%;width:78px;"
      >
        <p class="g-pstyle5">2024</p>
      </div>
      <div
        id="g-ai1-17"
        class="g-theme_copy_3 g-aiAbs g-aiPointText"
        style="top:98.1612%;margin-top:-9.9px;left:2.0001%;width:150px;"
      >
        <p class="g-pstyle6">The Garden of Time</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: md -->
  {#if width && width >= 660 && width < 930}
    <div id="g-years-outlines-md" class="g-artboard" style="">
      <div style="padding: 0 0 229.5455% 0;"></div>
      <div
        id="g-years-outlines-md-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/years-outlines-md.jpg);"
      ></div>
      <div
        id="g-ai2-1"
        class="g-explainer-text_copy_2 g-aiAbs g-aiPointText"
        style="top:3.6885%;margin-top:-25.9px;left:0.3082%;width:150px;"
      >
        <p class="g-pstyle0">Each grey line follows</p>
        <p class="g-pstyle0">the silhouette of an</p>
        <p class="g-pstyle0">outfit worn that year</p>
      </div>
      <div
        id="g-ai2-2"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.2688247089191%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.2688247089191%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.2688247089191%;top:11.4876%;margin-top:-22px;left:23.8693%;margin-left:-37px;width:74px;"
      >
        <p class="g-pstyle1">Fitted</p>
        <p class="g-pstyle1">torsos</p>
      </div>
      <div
        id="g-ai2-3"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);transform-origin: 50% 52.4102057148237%;-webkit-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-webkit-transform-origin: 50% 52.4102057148237%;-ms-transform: matrix(0.981,-0.1938,0.1938,0.981,0,0);-ms-transform-origin: 50% 52.4102057148237%;top:18.069%;margin-top:-20.7px;left:59.3833%;margin-left:-54px;width:108px;"
      >
        <p class="g-pstyle1">More layers</p>
        <p class="g-pstyle1">and ruffles</p>
      </div>
      <div
        id="g-ai2-4"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.8956,-0.4448,0.4448,0.8956,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.8956,-0.4448,0.4448,0.8956,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.8956,-0.4448,0.4448,0.8956,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:22.9469%;margin-top:-20.6px;left:93.8735%;margin-left:-56px;width:112px;"
      >
        <p class="g-pstyle1">Structured</p>
        <p class="g-pstyle1">shapes</p>
      </div>
      <div
        id="g-ai2-5"
        class="g-years_copy_2 g-aiAbs g-aiPointText"
        style="top:22.7814%;margin-top:-18.1px;left:-0.0395%;width:93px;"
      >
        <p class="g-pstyle2">2004</p>
      </div>
      <div
        id="g-ai2-6"
        class="g-theme_copy_2 g-aiAbs"
        style="top:23.7624%;left:-0.0395%;width:23.4848%;"
      >
        <p>Dangerous Liaisons, Fashion and Furniture in the 18th century</p>
      </div>
      <div
        id="g-ai2-7"
        class="g-years_copy_2 g-aiAbs g-aiPointText"
        style="top:28.788%;margin-top:-18.1px;left:30.09%;width:92px;"
      >
        <p class="g-pstyle2">2009</p>
      </div>
      <div
        id="g-ai2-8"
        class="g-theme_copy_2 g-aiAbs"
        style="top:29.769%;left:30.0899%;width:28.7879%;"
      >
        <p>The Model as Muse:</p>
        <p>Embodying Fashion</p>
      </div>
      <div
        id="g-ai2-9"
        class="g-years_copy_2 g-aiAbs"
        style="top:36.7657%;left:68.2938%;width:9.5455%;"
      >
        <p class="g-pstyle3">2014</p>
      </div>
      <div
        id="g-ai2-10"
        class="g-theme_copy_2 g-aiAbs"
        style="top:38.9439%;left:68.2938%;width:27.4242%;"
      >
        <p>Charles James:</p>
        <p>Beyond Fashion</p>
      </div>
      <div
        id="g-ai2-11"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:44.1746%;margin-top:-12.2px;left:19.9405%;margin-left:-50px;width:100px;"
      >
        <p class="g-pstyle1">Headpieces</p>
      </div>
      <div
        id="g-ai2-12"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.0206006551166%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.0206006551166%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.0206006551166%;top:51.6663%;margin-top:-24.7px;left:75.3933%;margin-left:-62.5px;width:125px;"
      >
        <p class="g-pstyle4">Breaking the</p>
        <p class="g-pstyle4">gown format</p>
      </div>
      <div
        id="g-ai2-13"
        class="g-years_copy_2 g-aiAbs g-aiPointText"
        style="top:66.6758%;margin-top:-18.1px;left:0.269%;width:85px;"
      >
        <p class="g-pstyle2">2019</p>
      </div>
      <div
        id="g-ai2-14"
        class="g-theme_copy_2 g-aiAbs"
        style="top:67.7228%;left:0.269%;width:38.7879%;"
      >
        <p>Camp: Notes on Fashion</p>
      </div>
      <div
        id="g-ai2-15"
        class="g-annot_copy_2 g-aiAbs g-aiPointText"
        style="transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);transform-origin: 50% 51.7214568501038%;-webkit-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-webkit-transform-origin: 50% 51.7214568501038%;-ms-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-ms-transform-origin: 50% 51.7214568501038%;top:80.7951%;margin-top:-29px;left:77.5996%;margin-left:-72px;width:144px;"
      >
        <p class="g-pstyle1">Petals, feathers,</p>
        <p class="g-pstyle1">shimmering</p>
        <p class="g-pstyle1">textures</p>
      </div>
      <div
        id="g-ai2-16"
        class="g-years_copy_2 g-aiAbs g-aiPointText"
        style="top:93.5405%;margin-top:-18.1px;left:31.3135%;width:91px;"
      >
        <p class="g-pstyle2">2024</p>
      </div>
      <div
        id="g-ai2-17"
        class="g-theme_copy_2 g-aiAbs g-aiPointText"
        style="top:95.3413%;margin-top:-10.4px;left:31.3133%;width:150px;"
      >
        <p class="g-pstyle5">The Garden of Time</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: lg -->
  {#if width && width >= 930 && width < 1200}
    <div id="g-years-outlines-lg" class="g-artboard" style="">
      <div style="padding: 0 0 233.0101% 0;"></div>
      <div
        id="g-years-outlines-lg-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/years-outlines-lg.jpg);"
      ></div>
      <div
        id="g-ai3-1"
        class="g-explainer-text_copy g-aiAbs g-aiPointText"
        style="top:2.4864%;margin-top:-25.9px;left:0.5413%;width:150px;"
      >
        <p class="g-pstyle0">Each grey line follows</p>
        <p class="g-pstyle0">the silhouette of an</p>
        <p class="g-pstyle0">outfit worn that year</p>
      </div>
      <div
        id="g-ai3-2"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.2688247089191%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.2688247089191%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.2688247089191%;top:5.8163%;margin-top:-22px;left:3.2835%;margin-left:-37px;width:74px;"
      >
        <p class="g-pstyle1">Fitted</p>
        <p class="g-pstyle1">torsos</p>
      </div>
      <div
        id="g-ai3-3"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.2688247089191%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.2688247089191%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.2688247089191%;top:19.9833%;margin-top:-22px;left:25.3605%;margin-left:-64px;width:128px;"
      >
        <p class="g-pstyle1">Flowy,</p>
        <p class="g-pstyle1">draping fabric</p>
      </div>
      <div
        id="g-ai3-4"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.0206006551166%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.0206006551166%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.0206006551166%;top:19.5545%;margin-top:-24.7px;left:59.4965%;margin-left:-54px;width:108px;"
      >
        <p class="g-pstyle2">More layers</p>
        <p class="g-pstyle2">and ruffles</p>
      </div>
      <div
        id="g-ai3-5"
        class="g-years_copy g-aiAbs g-aiPointText"
        style="top:21.8851%;margin-top:-22.2px;left:0.187%;width:110px;"
      >
        <p class="g-pstyle3">2004</p>
      </div>
      <div
        id="g-ai3-6"
        class="g-theme_copy g-aiAbs"
        style="top:22.7043%;left:0.187%;width:29.3548%;"
      >
        <p>Dangerous Liaisons, Fashion</p>
        <p>and Furniture in the 18th century</p>
      </div>
      <div
        id="g-ai3-7"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.8754,-0.4835,0.4835,0.8754,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.8754,-0.4835,0.4835,0.8754,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.8754,-0.4835,0.4835,0.8754,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:28.364%;margin-top:-20.6px;left:66.416%;margin-left:-58.5px;width:117px;"
      >
        <p class="g-pstyle1">Keeping with</p>
        <p class="g-pstyle1">fitted gown</p>
      </div>
      <div
        id="g-ai3-8"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.9597,-0.2811,0.2811,0.9597,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.9597,-0.2811,0.2811,0.9597,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.9597,-0.2811,0.2811,0.9597,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:29.7484%;margin-top:-20.6px;left:94.3618%;margin-left:-56px;width:112px;"
      >
        <p class="g-pstyle1">Structured</p>
        <p class="g-pstyle1">shapes</p>
      </div>
      <div
        id="g-ai3-9"
        class="g-years_copy g-aiAbs g-aiPointText"
        style="top:29.9146%;margin-top:-22.2px;left:34.114%;width:109px;"
      >
        <p class="g-pstyle3">2009</p>
      </div>
      <div
        id="g-ai3-10"
        class="g-theme_copy g-aiAbs"
        style="top:30.7338%;left:34.114%;width:20.4301%;"
      >
        <p>The Model as Muse:</p>
        <p>Embodying Fashion</p>
      </div>
      <div
        id="g-ai3-11"
        class="g-years_copy g-aiAbs g-aiPointText"
        style="top:41.3129%;margin-top:-22.2px;left:68.144%;width:100px;"
      >
        <p class="g-pstyle3">2014</p>
      </div>
      <div
        id="g-ai3-12"
        class="g-theme_copy g-aiAbs"
        style="top:42.1321%;left:68.144%;width:19.4624%;"
      >
        <p>Charles James:</p>
        <p>Beyond Fashion</p>
      </div>
      <div
        id="g-ai3-13"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:48.0041%;margin-top:-12.2px;left:22.5345%;margin-left:-50px;width:100px;"
      >
        <p class="g-pstyle1">Headpieces</p>
      </div>
      <div
        id="g-ai3-14"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.0206006551166%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.0206006551166%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.0206006551166%;top:55.5491%;margin-top:-24.7px;left:70.4904%;margin-left:-62.5px;width:125px;"
      >
        <p class="g-pstyle2">Breaking the</p>
        <p class="g-pstyle2">gown format</p>
      </div>
      <div
        id="g-ai3-15"
        class="g-years_copy g-aiAbs g-aiPointText"
        style="top:69.2318%;margin-top:-22.2px;left:0.187%;width:99px;"
      >
        <p class="g-pstyle3">2019</p>
      </div>
      <div
        id="g-ai3-16"
        class="g-theme_copy g-aiAbs"
        style="top:69.9125%;left:0.187%;width:27.5269%;"
      >
        <p class="g-pstyle4">Camp: Notes on Fashion</p>
      </div>
      <div
        id="g-ai3-17"
        class="g-annot_copy g-aiAbs g-aiPointText"
        style="transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);transform-origin: 50% 51.7214568501038%;-webkit-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-webkit-transform-origin: 50% 51.7214568501038%;-ms-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-ms-transform-origin: 50% 51.7214568501038%;top:83.8048%;margin-top:-29px;left:74.2105%;margin-left:-72px;width:144px;"
      >
        <p class="g-pstyle1">Petals, feathers,</p>
        <p class="g-pstyle1">shimmering</p>
        <p class="g-pstyle1">textures</p>
      </div>
      <div
        id="g-ai3-18"
        class="g-years_copy g-aiAbs g-aiPointText"
        style="top:94.2434%;margin-top:-22.2px;left:23.9031%;width:107px;"
      >
        <p class="g-pstyle3">2024</p>
      </div>
      <div
        id="g-ai3-19"
        class="g-theme_copy g-aiAbs g-aiPointText"
        style="top:95.5575%;margin-top:-14.7px;left:23.9031%;width:177px;"
      >
        <p class="g-pstyle5">The Garden of Time</p>
      </div>
    </div>
  {/if}
  <!-- Artboard: xl -->
  {#if width && width >= 1200}
    <div id="g-years-outlines-xl" class="g-artboard" style="">
      <div style="padding: 0 0 193.6691% 0;"></div>
      <div
        id="g-years-outlines-xl-img"
        class="g-aiImg"
        alt=""
        style="background-image: url({assetsPath.replace(
          new RegExp('/([^/.]+)$'),
          '/$1/'
        ) || '/'}images/graphics/years-outlines-xl.jpg);"
      ></div>
      <div
        id="g-ai4-1"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.2688247089191%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.2688247089191%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.2688247089191%;top:5.122%;margin-top:-22px;left:3.0558%;margin-left:-37px;width:74px;"
      >
        <p class="g-pstyle0">Fitted</p>
        <p class="g-pstyle0">torsos</p>
      </div>
      <div
        id="g-ai4-2"
        class="g-explainer-text g-aiAbs"
        style="top:4.3029%;left:19.5862%;width:12.4167%;"
      >
        <p class="g-pstyle1">Each grey line follows the</p>
        <p class="g-pstyle1">silhouette of an outfit</p>
        <p class="g-pstyle1">worn that year</p>
      </div>
      <div
        id="g-ai4-3"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.0206006551166%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.0206006551166%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.0206006551166%;top:16.7702%;margin-top:-24.7px;left:55.3179%;margin-left:-58.5px;width:117px;"
      >
        <p class="g-pstyle2">More layers</p>
        <p class="g-pstyle2">and ruffles</p>
      </div>
      <div
        id="g-ai4-4"
        class="g-annot g-aiAbs"
        style="transform: matrix(0.996,-0.0896,0.0896,0.996,0,0);transform-origin: 50% 52.2902234063783%;-webkit-transform: matrix(0.996,-0.0896,0.0896,0.996,0,0);-webkit-transform-origin: 50% 52.2902234063783%;-ms-transform: matrix(0.996,-0.0896,0.0896,0.996,0,0);-ms-transform-origin: 50% 52.2902234063783%;top:19.0975%;margin-top:-21.8px;left:23.2146%;margin-left:-4.4583%;width:8.9167%;"
      >
        <p class="g-pstyle3">Flowy,</p>
        <p class="g-pstyle3">draping fabric</p>
      </div>
      <div
        id="g-ai4-5"
        class="g-years g-aiAbs g-aiPointText"
        style="top:20.6214%;margin-top:-22.2px;left:0.0616%;width:110px;"
      >
        <p class="g-pstyle4">2004</p>
      </div>
      <div
        id="g-ai4-6"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:21.4991%;margin-top:-20.6px;left:68.5557%;margin-left:-58.5px;width:117px;"
      >
        <p class="g-pstyle0">Keeping with</p>
        <p class="g-pstyle0">fitted gown</p>
      </div>
      <div
        id="g-ai4-7"
        class="g-theme g-aiAbs"
        style="top:21.3853%;left:0.0616%;width:27.1667%;"
      >
        <p>Dangerous Liaisons, Fashion and Furniture in the 18th century</p>
      </div>
      <div
        id="g-ai4-8"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 52.4218916298101%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 52.4218916298101%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 52.4218916298101%;top:27.308%;margin-top:-20.6px;left:95.7138%;margin-left:-56px;width:112px;"
      >
        <p class="g-pstyle0">Structured</p>
        <p class="g-pstyle0">shapes</p>
      </div>
      <div
        id="g-ai4-9"
        class="g-years g-aiAbs g-aiPointText"
        style="top:29.1411%;margin-top:-22.2px;left:33.9383%;width:109px;"
      >
        <p class="g-pstyle4">2009</p>
      </div>
      <div
        id="g-ai4-10"
        class="g-theme g-aiAbs"
        style="top:29.905%;left:33.9383%;width:18.8333%;"
      >
        <p>The Model as Muse: Embodying Fashion</p>
      </div>
      <div
        id="g-ai4-11"
        class="g-years g-aiAbs g-aiPointText"
        style="top:39.0807%;margin-top:-22.2px;left:67.5616%;width:100px;"
      >
        <p class="g-pstyle4">2014</p>
      </div>
      <div
        id="g-ai4-12"
        class="g-theme g-aiAbs"
        style="top:39.8446%;left:67.5616%;width:28.1667%;"
      >
        <p>Charles James: Beyond Fashion</p>
      </div>
      <div
        id="g-ai4-13"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);transform-origin: 50% 54.0832602280884%;-webkit-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-webkit-transform-origin: 50% 54.0832602280884%;-ms-transform: matrix(0.97,-0.2429,0.2429,0.97,0,0);-ms-transform-origin: 50% 54.0832602280884%;top:43.4265%;margin-top:-12.2px;left:24.2976%;margin-left:-50px;width:100px;"
      >
        <p class="g-pstyle0">Headpieces</p>
      </div>
      <div
        id="g-ai4-14"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);transform-origin: 50% 52.0206006551166%;-webkit-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-webkit-transform-origin: 50% 52.0206006551166%;-ms-transform: matrix(0.9995,-0.0312,0.0312,0.9995,0,0);-ms-transform-origin: 50% 52.0206006551166%;top:52.2259%;margin-top:-24.7px;left:67.2756%;margin-left:-62.5px;width:125px;"
      >
        <p class="g-pstyle2">Breaking the</p>
        <p class="g-pstyle2">gown format</p>
      </div>
      <div
        id="g-ai4-15"
        class="g-years g-aiAbs g-aiPointText"
        style="top:67.6948%;margin-top:-22.2px;left:0.0616%;width:99px;"
      >
        <p class="g-pstyle4">2019</p>
      </div>
      <div
        id="g-ai4-16"
        class="g-theme g-aiAbs"
        style="top:68.4157%;left:0.0616%;width:21.3333%;"
      >
        <p class="g-pstyle5">Camp: Notes on Fashion</p>
      </div>
      <div
        id="g-ai4-17"
        class="g-annot g-aiAbs g-aiPointText"
        style="transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);transform-origin: 50% 51.721442380432%;-webkit-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-webkit-transform-origin: 50% 51.721442380432%;-ms-transform: matrix(0.9987,0.0509,-0.0509,0.9987,0,0);-ms-transform-origin: 50% 51.721442380432%;top:83.7789%;margin-top:-29px;left:76.1765%;margin-left:-72px;width:144px;"
      >
        <p class="g-pstyle0">Petals, feathers,</p>
        <p class="g-pstyle0">shimmering</p>
        <p class="g-pstyle0">textures</p>
      </div>
      <div
        id="g-ai4-18"
        class="g-years g-aiAbs g-aiPointText"
        style="top:96.0077%;margin-top:-22.2px;left:33.9383%;width:107px;"
      >
        <p class="g-pstyle4">2024</p>
      </div>
      <div
        id="g-ai4-19"
        class="g-theme g-aiAbs g-aiPointText"
        style="top:97.2331%;margin-top:-14.7px;left:33.9383%;width:177px;"
      >
        <p class="g-pstyle6">The Garden of Time</p>
      </div>
    </div>
  {/if}
</div>
<!-- End ai2html - 2025-05-02 14:44 -->

<!-- Generated by ai2html v0.100.0 - 2025-05-02 14:44 -->
<!-- ai file: years-outlines.ai -->
<style lang="scss">
  #g-years-outlines-box,
  #g-years-outlines-box .g-artboard {
    margin: 0 auto;
  }
  #g-years-outlines-box p {
    margin: 0;
  }
  #g-years-outlines-box .g-aiAbs {
    position: absolute;
  }
  #g-years-outlines-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-years-outlines-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-years-outlines-xs {
    position: relative;
    overflow: hidden;
  }
  #g-years-outlines-xs p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-years-outlines-xs .g-pstyle0 {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    letter-spacing: 0.005em;
    font-size: 13px;
    color: rgb(64, 64, 64);
  }
  #g-years-outlines-xs .g-pstyle1 {
    height: 14px;
    text-align: center;
  }
  #g-years-outlines-xs .g-pstyle2 {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    text-align: right;
    color: rgb(36, 36, 36);
  }
  #g-years-outlines-xs .g-pstyle3 {
    font-family: LibreBodoni-Regular;
    line-height: 15px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-xs .g-pstyle4 {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    color: rgb(36, 36, 36);
  }
  #g-years-outlines-xs .g-pstyle5 {
    font-family: LibreBodoni-Regular;
    line-height: 15px;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-xs .g-pstyle6 {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 19px;
    height: 19px;
    font-size: 16px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-xs .g-pstyle7 {
    font-family: LibreBodoni-Regular;
    line-height: 15px;
    height: 15px;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-sm {
    position: relative;
    overflow: hidden;
  }
  #g-years-outlines-sm p {
    font-family: BethEllen-Regular;
    font-weight: 400;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-years-outlines-sm .g-pstyle0 {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 16px;
    height: 16px;
    letter-spacing: 0.005em;
    font-size: 13px;
    color: rgb(64, 64, 64);
  }
  #g-years-outlines-sm .g-pstyle1 {
    height: 17px;
    text-align: center;
  }
  #g-years-outlines-sm .g-pstyle2 {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 25px;
    height: 25px;
    font-size: 21px;
    text-align: right;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-sm .g-pstyle3 {
    font-family: LibreBodoni-Regular;
    height: 17px;
    text-align: right;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-sm .g-pstyle4 {
    line-height: 16px;
    height: 16px;
    text-align: center;
  }
  #g-years-outlines-sm .g-pstyle5 {
    font-family: LibreBodoni-Regular;
    font-weight: 700;
    line-height: 25px;
    height: 25px;
    font-size: 21px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-sm .g-pstyle6 {
    font-family: LibreBodoni-Regular;
    height: 17px;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-sm .g-pstyle7 {
    font-family: LibreBodoni-Regular;
    color: rgb(102, 102, 102);
  }
  #g-years-outlines-md {
    position: relative;
    overflow: hidden;
  }
  #g-years-outlines-md p {
    font-family: LibreBodoni-Regular;
    font-weight: 400;
    line-height: 18px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-years-outlines-md .g-pstyle0 {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.005em;
    color: rgb(64, 64, 64);
  }
  #g-years-outlines-md .g-pstyle1 {
    font-family: BethEllen-Regular;
    line-height: 17px;
    height: 17px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-md .g-pstyle2 {
    font-weight: 700;
    line-height: 31px;
    height: 31px;
    font-size: 26px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-md .g-pstyle3 {
    font-weight: 700;
    line-height: 31px;
    font-size: 26px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-md .g-pstyle4 {
    font-family: BethEllen-Regular;
    line-height: 21px;
    height: 21px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-md .g-pstyle5 {
    height: 18px;
  }
  #g-years-outlines-lg {
    position: relative;
    overflow: hidden;
  }
  #g-years-outlines-lg p {
    font-family: LibreBodoni-Regular;
    font-weight: 400;
    line-height: 24px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-years-outlines-lg .g-pstyle0 {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.005em;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-years-outlines-lg .g-pstyle1 {
    font-family: BethEllen-Regular;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-lg .g-pstyle2 {
    font-family: BethEllen-Regular;
    line-height: 21px;
    height: 21px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-lg .g-pstyle3 {
    font-weight: 700;
    line-height: 38px;
    height: 38px;
    font-size: 32px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-lg .g-pstyle4 {
    line-height: 26px;
  }
  #g-years-outlines-lg .g-pstyle5 {
    line-height: 26px;
    height: 26px;
  }
  #g-years-outlines-xl {
    position: relative;
    overflow: hidden;
  }
  #g-years-outlines-xl p {
    font-family: LibreBodoni-Regular;
    font-weight: 400;
    line-height: 24px;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 17px;
    text-align: left;
    color: rgb(102, 102, 102);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-years-outlines-xl .g-pstyle0 {
    font-family: BethEllen-Regular;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-xl .g-pstyle1 {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 300;
    line-height: 17px;
    letter-spacing: 0.005em;
    font-size: 14px;
    color: rgb(64, 64, 64);
  }
  #g-years-outlines-xl .g-pstyle2 {
    font-family: BethEllen-Regular;
    line-height: 21px;
    height: 21px;
    font-size: 14px;
    text-align: center;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-xl .g-pstyle3 {
    font-family: BethEllen-Regular;
    line-height: 17px;
    font-size: 14px;
    color: rgb(0, 0, 0);
  }
  #g-years-outlines-xl .g-pstyle4 {
    font-weight: 700;
    line-height: 38px;
    height: 38px;
    font-size: 32px;
    color: rgb(41, 41, 41);
  }
  #g-years-outlines-xl .g-pstyle5 {
    line-height: 26px;
  }
  #g-years-outlines-xl .g-pstyle6 {
    line-height: 26px;
    height: 26px;
  }

  /* Custom CSS */
  .g-text {
  }
</style>
